module.exports = __webpack_public_path__ + "images/f9b50647698a6553d5efa30faf28ccf8.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/6.png
// module id = 382
// module chunks = 0